import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-600">
          <i className="ri-compass-3-line text-4xl"></i>
        </div>
        <h1 className="text-4xl md:text-6xl font-bold text-foreground-950 mb-3">404</h1>
        <p className="text-foreground-500 text-sm md:text-base mb-8">抱歉，您访问的页面不存在或已被移除。</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}